<template>
  <button
    v-if="storeInfo"
    id="MY_STORE"
    class="category-button grid-x align-middle"
    data-testid="My store"
    data-flyout-id="store"
    tabindex="0"
    @click="showStoreInfo"
    @keydown.enter.prevent="handlePressEnter"
  >
    <i class="store-mode margin-right-xs"></i>

    <span class="grid-y align-justify align-items-start">
      <span class="category-text store-name regular">{{ storeInfo.name || defaultStoreName }}</span>
      <span v-if="storeInfo.schedule" class="store-info-hours operation-hours">
        <span
          class="operation-hours"
          :class="{
            'store-open': storeInfo.isOpen,
            'store-closed': !storeInfo.isOpen,
          }"
        >
          {{ storeInfo.operationState }}
        </span>
        <span class="operation-hours time">{{ storeInfo.operationHours }}</span>
      </span>
    </span>

    <i class="chevron-small-right-black chevron-small-right chevron-icon"></i>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { defaultStoreName } from 'config';

import { GET_STORE_INFO } from '#shared/types/getters';
import { tagNavLinkClick } from '#shared/features/analytics/navigationTags';
import focusAfterTransition from '~/utils/focusAfterTransition';

const emit = defineEmits(['onSelect']);

const envProps = useEnvProps();
const pageData = usePageData();
const navPreferred = useNavPreferred();
const navViewType = useNavViewType();

const isMcom = envProps.isMcom;
const { context } = pageData.navigation;

const storeInfo = computed(() => navPreferred?.[GET_STORE_INFO]);
const viewType = computed(() => navViewType.viewType);

function showStoreInfo() {
  if (isMcom) {
    tagNavLinkClick(
      isMcom,
      {
        context: context.value,
        topCategoryName: '',
        pos: 1,
        col: 1,
        categoryId: '',
        clickableElement: storeInfo.value.name + storeInfo.value.operationState + storeInfo.value.operationHours,
      },
      viewType.value,
      { isShopAll: true },
    );
  }

  emit('onSelect', { id: 'store', title: 'My Store' });
}

function handlePressEnter() {
  showStoreInfo();
  focusAfterTransition({
    query: '.mobile-store-info a, .mobile-store-info button',
    panelClass: '.transition-panel',
  });
}
</script>

<style lang="scss" scoped>
button {
  width: 100%;
}

.chevron-icon {
  margin-left: auto;
}

.operation-hours.time {
  text-transform: lowercase;
}

span.store-open {
  color: $green;
}

.store-name {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}

.store-info-hours {
  text-align: left;
}
</style>

<style lang="scss" scoped brand="mcom">
@import '~/assets/scss/mixins.mcom.scss';

span.store-closed {
  color: $highlight-color;
}

.operation-hours {
  @include body(small);
}
</style>

<style lang="scss" scoped brand="bcom">
@import '~/assets/scss/mixins.bcom.scss';

.store-mode {
  display: none;
}

span.store-closed {
  color: $error-color;
}

.operation-hours {
  @include body(regular);
}
</style>
